// extracted by mini-css-extract-plugin
export default {"item":"styles_item__8bGe2","inline":"styles_inline__ufQJr","label":"styles_label__My0Jp","value":"styles_value__mg89v"};